import { useState } from "react";
import {
  Box,
  Button,
  Input,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Center,
} from "@chakra-ui/react";
import { useChatBot } from "../api";
import MarkDownRender from "../../../renderer/MarkDownRender";

// Define the structure of the dataset
interface DataItem {
  x: number;
  y: number;
}

type PatternTableIProps = {
  data: DataItem[];
  showInput: boolean;
  question: string;
  system?: string;
};

const PatternTable = ({
  data,
  showInput,
  question,
  system,
}: PatternTableIProps) => {
  const [input, setInput] = useState<number | string>("");
  const [prediction, setPrediction] = useState<number | null>(null);
  const chatbot = useChatBot();

  const handlePredict = async () => {
    if (!input) {
      return;
    }

    let value = [...data, { x: Number(input), y: "?" }];

    chatbot.mutate(
      {
        system:
          system ??
          "You are a small linear regression modal for prediction and give output in number, No Extra Content",
        prompt: JSON.stringify(value),
      },
      {
        onSuccess: (res) => {
          setPrediction(res.response);
        },
        onError: () => {},
      }
    );
  };

  return (
    <Box p={"1rem"}>
      <Box
        maxW={{ base: "17rem", md: "20rem" }}
        overflow={"hidden"}
        border={"1px solid"}
        mx={"auto"}
        borderRadius={"1rem"}
        borderColor={"purple.500"}
      >
        <Table variant="simple">
          <Thead>
            <Tr bg={"purple.900"}>
              <Th
                py={"1rem"}
                borderRight={"1px"}
                fontFamily={"italic"}
                borderRightColor={"purple.700"}
                color={"foreground"}
              >
                X
              </Th>
              <Th fontFamily={"italic"} color={"foreground"}>
                Y
              </Th>
            </Tr>
          </Thead>
          <Tbody>
            {data.map((item, index) => (
              <Tr key={index}>
                <Td
                  width={"50%"}
                  borderColor={"purple.900"}
                  textAlign={"right"}
                  borderRight={"1px solid"}
                  borderRightColor={"purple.900"}
                >
                  {item.x}
                </Td>
                <Td borderColor={"purple.900"} textAlign={"right"}>
                  {item.y}
                </Td>
              </Tr>
            ))}
            {showInput && (
              <Tr h={"3.3rem"} bg={"whiteAlpha.100"}>
                <Td
                  fontWeight={"bold"}
                  textAlign={"right"}
                  color={"purple.500"}
                  borderRight={"1px solid"}
                  borderColor={"purple.900"}
                >
                  {input}
                </Td>
                <Td
                  fontWeight={"bold"}
                  color={"purple.500"}
                  textAlign={"right"}
                >
                  {prediction}
                </Td>
              </Tr>
            )}
          </Tbody>
        </Table>
      </Box>
      <Box pt={showInput ? "2rem" : "0rem"}>
        <Center>
          <MarkDownRender content={question} />
        </Center>
        <Center>
          {showInput && (
            <Input
              maxWidth={"5rem"}
              height={"4rem"}
              type="number"
              placeholder="Input a number"
              value={input}
              width={"content-fit"}
              onChange={(e) => {
                setInput(e.target.value);
                setPrediction(null);
              }}
              mb={4}
            />
          )}
        </Center>
        <Center>
          {showInput && (
            <Button
              variant={"teronary"}
              isLoading={chatbot.isPending}
              colorScheme="teal"
              onClick={handlePredict}
            >
              Predict AI's Guess
            </Button>
          )}
        </Center>
      </Box>
    </Box>
  );
};

export default PatternTable;
